import React, { useContext } from "react";
import { FilterContext } from "../index";
// import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
function Footer(props) {

  const { applyFilters, attributeList, filterName, actionType } = useContext(FilterContext);
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "flex-end",
        marginTop: "32px",
        marginBottom: "16px",
      }}
    >
      
      <button style={{ backgroundColor: "#FFF", fontWeight: 500, border: '1px solid #e0e0e0', cursor: "pointer", 
        color: '#424242', fontSize: '14px', borderRadius: '6px', background:"white", width: '79px', height: '37px'}}
        onClick={props.onModalClose}
      >Cancel</button>

      <button
       style={{
        width: "142px",
        height:"37px",
        fontWeight: 600,
        letterSpacing: "8%",
        verticalAlign: "Top",
        background: !(
          attributeList[attributeList.length-1]?.isValid ||
          attributeList[attributeList.length-1]?.isValid === undefined
        ) || attributeList[attributeList.length-1].attribute === ""? "#cccccc" : "rgba(1, 107, 64, 1)",
        color: "#FFFFFF",
        border: "1px",
        borderRadius: '6px',
        marginLeft: 10,
        cursor:!(
          attributeList[attributeList.length-1]?.isValid ||
          attributeList[attributeList.length-1]?.isValid === undefined
        ) || attributeList[attributeList.length-1].attribute === "" ? "" : "pointer",
      }}
      disabled={!(
        attributeList[attributeList.length-1]?.isValid ||
        attributeList[attributeList.length-1]?.isValid === undefined
      ) || attributeList[attributeList.length-1].attribute === ""}
        onClick={() => {
          if (props.checked) {
            if(filterName === ''){
              document.getElementById("filter-name-header").focus();
              console.log('on click of button when add and checked and no name');
            }else{
              applyFilters("SAVE_APPLY");
              console.log('on click of button when add and checked and with name');
            }
            
          } 
          else {
            if (actionType === "ADD") {
              applyFilters("ONLY_APPLY");
              console.log('on click of button when add and not checked ');
            } else {
              console.log('on click of button when add and not checked in else ');
              applyFilters("APPLY");
            }
          }
          props.setActionType('')
        }}
      >
        Apply Filter
      </button>
    </div>
  );
}

export default Footer;